import type { SearchGatedUserProfile } from '../types/search-gated-user-profile.type';
import { getNameForCandidate } from './get-name-for-candidate.util';
import { toSafeHighlightHtml, toSafePlainHtml } from '@/utils/strings/safe-highlight-html.util';

/**
 * Returns the candidate's name as HTML for a `v-html` sink: highlight fragments keep only
 * their `<b>` markers and stored names are escaped, since both are candidate-written.
 */
export function getHighlightedName(pro?: SearchGatedUserProfile): string {
  const fallbackName = toSafePlainHtml(getNameForCandidate(pro));
  if (!pro) return fallbackName;

  const es = pro._esHighlight;
  if (es) {
    const nameFirst = es.nameFirst?.[0];
    const nameLast = es.nameLast?.[0];
    return (
      [
        nameFirst ? toSafeHighlightHtml(nameFirst) : toSafePlainHtml(pro.nameFirst ?? ''),
        nameLast ? toSafeHighlightHtml(nameLast) : toSafePlainHtml(pro.nameLast ?? ''),
      ]
        .filter(Boolean)
        .join(' ')
        .trim() || fallbackName
    );
  }

  const hl = pro._highlight;
  if (hl?.nameFirst || hl?.nameLast) {
    const nameFirst = hl.nameFirst?.value;
    const nameLast = hl.nameLast?.value;
    const highlighted = [
      nameFirst ? toSafeHighlightHtml(nameFirst) : toSafePlainHtml(pro.nameFirst ?? ''),
      nameLast ? toSafeHighlightHtml(nameLast) : toSafePlainHtml(pro.nameLast ?? ''),
    ]
      .filter(Boolean)
      .join(' ')
      .trim();
    return highlighted || fallbackName;
  }

  return fallbackName;
}
